import styles from './links.less'; export {styles};
import Link from './links/link';
import {MenuLinkData} from '../../shared/menu';

export interface LinksProps {
    className?: string;
    children: MenuLinkData[];
    currentCategoryIds?: string[];
    level: number;
}

export default class Links extends React.Component<LinksProps, null> {

    render() {
        return (
            <ul className={classNames(this.props.className, styles['level-' + this.props.level], styles.children)}>
                {this.props.children.map((link, idx) =>
                    <Link
                        id={link.id}
                        key={link.id || idx}
                        name={link.name}
                        url={link.url}
                        children={link.children}
                        currentCategoryIds={this.props.currentCategoryIds}
                        level={this.props.level}
                    />
                )}
            </ul>
        );
    }
}
